import { CSSProperties } from 'react'

import sequenceTaskTemplateIcon from '@assets/images/sequence-task-icon.svg'
import sequenceTimerIcon from '@assets/images/sequence-timer-icon.svg'

import { SequenceLibrary, SequenceTemplate } from '@types'

import { SequenceTemplatePreview } from '../SequenceTemplatePreview'

import {
  ResumeContainer,
  Container,
  IconImg,
  LabelSequenceTemplate,
  ValueContainer,
  ValueLabel,
} from './SequenceTemplateThumb.styled'

interface Props {
  sequence: SequenceTemplate | SequenceLibrary
  style?: CSSProperties
  view?: 'list' | 'calendar'
  draggable?: boolean
  selected?: boolean
  onClick?: (sequence: SequenceTemplate | SequenceLibrary) => void
  isDragging?: boolean
}

export const SequenceTemplateThumb = (props: Props): JSX.Element => {
  const {
    view = 'list',
    sequence,
    sequence: { name, tasks },
    style,
    draggable,
    selected,
    onClick,
    isDragging,
  } = props

  const duration = tasks.reduce((acc, task) => {
    const duration = task.startDay + task.duration
    return duration > acc ? duration : acc
  }, 0)

  return (
    <Container
      onClick={() => onClick?.(sequence)}
      style={style}
      className={view}
      draggable={draggable}
      selected={selected}
      isDragging={isDragging}
    >
      <LabelSequenceTemplate>{name}</LabelSequenceTemplate>
      <ResumeContainer>
        <ValueContainer>
          <IconImg src={sequenceTaskTemplateIcon} />
          <ValueLabel>{tasks.length}</ValueLabel>
        </ValueContainer>

        <ValueContainer>
          <IconImg src={sequenceTimerIcon} />
          <ValueLabel>{duration}j</ValueLabel>
        </ValueContainer>
      </ResumeContainer>

      <SequenceTemplatePreview sequence={sequence} />
    </Container>
  )
}
